// extracted by mini-css-extract-plugin
export default {"container":"not-found_container__BSnpp","image":"not-found_image__z+tRG","title":"not-found_title__ekp2L","subtitle":"not-found_subtitle__x1k-H"};